<template>
  <form @submit.prevent="onSubmitForm">
    <vs-input
      class="w-full"
      label="Название помещения, согласно проектной декларации"
      v-model="form.title"
      :danger="errors.title"
      danger-text="Обязательное поле"
      @input="errors.title = !$event"
    />
    <div :class="$style.apartmentsContainer">
      <div :class="$style.label">Помещения:</div>
      <form>
        <div :class="$style.apartmentsList">
          <ag-grid-table
            ref="table"
            :getData="getApartments"
            :columns="apartmentsColumns"
            :rowsHeight="50"
            no-data-text="Группы помещений не найдены"
            row-selection="multiple"
            @grid-ready="onGridReady"
          />
        </div>
      </form>
    </div>
    <div :class="$style.footer">
      <vs-button button="submit" type="border" color="success">{{ buttonText }}</vs-button>
    </div>
  </form>
</template>

<script>
import modalContext        from "@/mixins/modalContext";
import notifyHttpError     from "@/mixins/notifyHttpError";
import TypeRenderer        from "@/components/employee/accounts/TypeRenderer";
import * as apartmentTypes from '@/client/dictionaries/apartmentTypes';

export default {
  name:    "ApartmentsGroupsFormPopup",
  mixins:  [modalContext, notifyHttpError],
  props:   ['buildingId', 'buttonText', 'onSubmit', 'title', 'apartments'],
  data() {
    return {
      isProgress:        false,
      form:              {
        title: this.title || '',
      },
      errors:            {
        title: null,
      },
      apartmentsColumns: [
        {
          headerName:  '№',
          headerClass: 'left',
          cellClass:   'left',
          field:       'number',
          minWidth:    85,
        },
        {
          headerName:            'Тип',
          field:                 'type_apart',
          cellRendererFramework: TypeRenderer,
          filter:                'select',
          filterParams:          {
            options:    apartmentTypes.getSelectOptions(),
          },
        },
        {
          headerName:  'Счет',
          headerClass: 'left',
          cellClass:   'left',
          field:       'account_number',
          minWidth:    100,
          // width:       100,
        },
        {
          headerName:  'Собственник',
          field:       'b_owner',
          headerClass: 'left',
          cellClass:   'left',
          flex:        2,
          // minWidth:    320,
        },
        {
          headerName:                          'Выбрать все:',
          field:                               '',
          minWidth:                            125,
          headerClass:                         'checkbox',
          cellClass:                           'checkbox',
          sortable:                            false,
          filter:                              false,
          headerCheckboxSelection:             true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection:                   true,
        },
      ],
      gridApi:           null,
    };
  },
  methods: {
    getApartments() {
      return this.$http.get(`/building/${this.buildingId}/apartment`, { params: { buildings_id: this.buildingId } }).then(( { data } ) => data.data);
    },

    onGridReady( gridApi ) {
      this.gridApi = gridApi;
      gridApi.addEventListener('rowDataChanged', ( e ) => {
        const apartmentsDict = this.apartments ? this.apartments.reduce(( dict, apartmentId ) => {
          dict[apartmentId] = true;
          return dict;
        }, {}) : {};
        this.$refs.table.gridApi.forEachNode(( node ) => {
          node.setSelected(apartmentsDict[node.data.id]);
        });
      });
    },

    onSubmitForm() {
      if (this.isProgress) return;

      const data = {
        title:      this.form.title.trim(),
        apartments: this.gridApi.getSelectedNodes().map(row => row.data.id),
      };

      if (!data.title) {
        this.errors.title = true;
        return;
      }

      this.isProgress = true;
      this.onSubmit(data).then(
        () => this.modalResolve(),
        this.notifyHttpError,
      ).finally(() => this.isProgress = false);
    },
  },
};
</script>

<style lang="scss" module>
.footer {
  text-align: center;
  margin-top: 1em;
}

.apartmentsContainer {
  margin-top: 1em;
}

.apartmentsList {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  :global(.ag-grid-infinite-wrapper) {
    min-height: 0;
  }
}

.label {
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(var(--app-heading-color-light), 1);
}
</style>
